
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import '@fortawesome/fontawesome-free/css/all.min.css';
import '../App.css';
// import emailjs from 'emailjs-com';

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
function ContactHome() {
     const [userData, setUserData] = useState({});
      const [aadhaarFile, setAadhaarFile] = useState(null);
      const navigate = useNavigate();
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
      };
    
      const handleFileChange = (e) => {
        setAadhaarFile(e.target.files[0]);
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
    
        Object.entries(userData).forEach(([key, value]) => {
          formData.append(key, value);
        });
    
      
        try {
          const response = await fetch("https://api.sarvashaktidal.org/publicApi/createContact", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
          });
          const data = await response.json();
    
            if (response.ok) {
        alert(data.message || "Enquiry submitted successfully!");
      
      }  else {
            toast.error(data.message || "Registration failed");
          }
        } catch (error) {
          toast.error("Something went wrong.");
        }
      }; 
  return (
    <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #f5f3f3ff, #e6e1e1ff)' }}>
      <div className="container-fluid">
        <div className="row align-items-center p-3">
          {/* Left Side - Image */}
          <div className="col-12 col-md-6 ps-0 my-4">
            <img
              src="https://media.licdn.com/dms/image/v2/D4E12AQFddwTDMMJ-Tw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1729506294699?e=2147483647&v=beta&t=gk6IKIdGdhJ4H73iSi8jeNpBCByIgKxQxMuUFiqTMHQ"
              alt="Contact"
              className="rounded-4 shadow w-100 product-img-out"
             
            />
          </div>

          {/* Right Side - Form */}
          <div className="col-12 col-md-6 bg-white rounded-4 shadow p-4 my-4">
            <h6 className="text-uppercase fw-bold text-danger fw-bold mb-2">Contact Us</h6>
            <h2 className="fw-bold mb-4">Get in Touch with Chitracrop Science</h2>

            {/* Success/Error Message */}
            {/* {message && <div className="alert alert-info">{message}</div>} */}

            <form >
              <div className="row g-3">
                {/* First + Last Name */}
                <div className="col-12">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter First Name"
                    required
                 onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    placeholder="Enter Your City"
                 onChange={handleChange} />
                </div>

                {/* Email + Phone */}
                <div className="col-12">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email Address"
                    required
                 onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-control"
                    placeholder="9950xxxxx18"
                    required
                 onChange={handleChange} />
                </div>

                {/* Subject */}
                {/* <div className="col-12">
                  <label className="form-label">Subject</label>
                  <input type="text" name="subject" className="form-control" placeholder="Subject" onChange={handleChange}/>
                </div> */}

                {/* Message */}
                {/* <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Your Message"
                 onChange={handleChange} ></textarea>
                </div> */}

                {/* Submit */}
                <div className="col-12">
                  <button type="submit" className="btn btn-danger px-4 fw-bold" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactHome;
